import * as React from 'react'
import Stack from '@mui/material/Stack'
import { useCreateOppActions } from '@user/components/Location'
import { NoteCode } from '@user/components/Notes/typings'
import { NextActionDate, Note } from '../FormComponents'
import { Measure } from '@user/components/DetailPages/sections/EntityName/MeasureAI/Measure'
import { ILeadFormModel } from '../typings'
import { useFormikContext } from 'formik'
import { usePropertyDetailsEnabled } from '@user/components/DetailPages/sections/EntityName/MeasureAI/hooks/usePropertyDetailsEnabled'
import { DuplicateAlertNew } from '@user/components/Leads/AddLeadPage/FormComponents/DuplicateAlert/DuplicateAlertNew'

type Props = {
  startFromNotes?: boolean
  hideOptional: boolean
  noteCodes: NoteCode[]
  fromMapView?: boolean
}

export function RightRail(props: Props) {
  const { hideOptional, noteCodes, startFromNotes, fromMapView = false } = props
  const createOppActions = useCreateOppActions(true)

  const measureAIEnabled = usePropertyDetailsEnabled()
  const {
    values: { fullAddress },
  } = useFormikContext<ILeadFormModel>()

  return (
    <Stack direction="column" sx={{ width: '100%' }} spacing={2}>
      {startFromNotes && (
        <Note
          fromMapView={fromMapView}
          hideOptional={hideOptional}
          variant="standard"
          noteCodes={noteCodes}
        />
      )}
      {!fromMapView && (
        <DuplicateAlertNew createOppActions={createOppActions} />
      )}
      <NextActionDate fieldName="nextActionDate" hideOptional={hideOptional} />
      {!startFromNotes && (
        <Note
          fromMapView={fromMapView}
          hideOptional={hideOptional}
          variant="card"
          noteCodes={noteCodes}
        />
      )}
      {!fromMapView && measureAIEnabled && fullAddress && (
        <Measure address={fullAddress} variant="location" />
      )}
    </Stack>
  )
}
